$(document).ready(function () {
	  
	$('#wrap-ma-mobilemenu').css('display','none');
	
	$("ul.mobilemenu li.active").each(function(){
		$(this).children().next("ul").css('display', 'block');
	});
         $("ul.mobilemenu li ul").hide();
		 
 	 $(document).ready(function(){
			$('li span.ttclose').click(function() { 
			if ($(this).hasClass('ttopen')) {varche = true} else {varche = false};
			if(varche == false){
				$(this).addClass("ttopen");
				$(this).removeClass("ttclose");
				$(this).next('ul').slideDown();
				varche = true;
			} else 
			{	
				$(this).removeClass("ttopen");
				$(this).addClass("ttclose");
				$(this).next('ul').slideUp();
				varche = false;
			}
			});
		});
    
	//mobile
	$('.btn-navbar').click(function() {
		
		var chk = 0;
		if ( $('#navbar-inner').hasClass('navbar-inactive') && ( chk==0 ) ) {
			$('#navbar-inner').removeClass('navbar-inactive');
			$('#navbar-inner').addClass('navbar-active');
			$('#wrap-ma-mobilemenu').css('display','block');
			$('#ma-mobilemenu').css('display','block');
			chk = 1;
		}
		if ($('#navbar-inner').hasClass('navbar-active') && ( chk==0 ) ) {
			$('#navbar-inner').removeClass('navbar-active');
			$('#navbar-inner').addClass('navbar-inactive');	
			$('#wrap-ma-mobilemenu').css('display','none');			
			$('#ma-mobilemenu').css('display','none');
			chk = 1;
		}
		//$('#ma-mobilemenu').slideToggle();
	});    
    
});